import openFlexPaneHelper from "owa-app-pane-group-utils/lib/helpers/openFlexPaneHelper";

export default function launchSuiteHelpPane(): void {
    openFlexPaneHelper("Help", "help");
}
